export default "<template>\n\n  <div style=\"padding: 24px\">\n    <KCircularLoader type=\"indeterminate\" />\n  </div>\n\n</template>\n";